import { IntegrationServices } from '@sequencehq/api'
import { INTEGRATION_DETAILS } from 'Integrations/index'

export function integrationName(
  integrationService: IntegrationServices
): string {
  return (
    INTEGRATION_DETAILS[integrationService]?.label ??
    integrationService.replaceAll('_', ' ')
  )
}
